import pino from 'pino';
const log = pino({ level: 'info' });
export default log;
